import { useQuery } from '@tanstack/react-query';
import { supabase } from '../../api';

const getServices = async (salonId: string, selectedLocation: string, servicesIds: string[]) => {
  const { data: services, error: servicesError } = await supabase
    .from('services')
    .select('id')
    .eq('salon', salonId)
    .eq('service_location', selectedLocation);

  if (servicesError) {
    console.log('Error whilte ferching services: ', servicesError.message);
  }
  console.log("services: ", services)
  console.log("servicesIds: ", servicesIds)

  if (!services || services.length === 0) {
    return [];
  }

  const { data: servicePricingDuration, error: servicePricingDurationError } = await supabase
    .from('service_pricing_duration')
    .select('*,services(*)')
    .in(
      'service',
      servicesIds,
    );


  if (servicePricingDurationError) {
    console.log(
      'Error whilte ferching service pricing duration: ',
      servicePricingDurationError.message,
    );
  }

  return servicePricingDuration;
};

export default function useGetServicePricingDurationBySpec(salonId: string, selectedLocation: string, servicesIds: string[]) {
  return useQuery({
    queryKey: ['useGetServicePricingDurationBySpec', salonId, selectedLocation, servicesIds],
    queryFn: () => getServices(salonId, selectedLocation, servicesIds),
    staleTime: 0,
  });
}
